import React, { useState } from 'react';
import {
  FaCircle,
  FaExchangeAlt,
  FaHeadset,
  FaPhone,
  FaPhoneSlash
} from 'react-icons/fa';
import './style.css';
import userAgentSingleton from '../userAgent/userAgentSingleton';
import { SessionState } from 'sip.js';
import { MdHeadset, MdHeadsetOff, MdMic, MdMicOff } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import { FiLogOut, FiMonitor } from 'react-icons/fi';
import { verifyRoles } from 'components/Authentication/VerifyRoles';

const DialpadWebRTC = ({
  ramal,
  onDisconnect,
  callState,
  callStateColor,
  callStateStatus,
  receivedInvitation,
  setOpen
}) => {
  const [currentDialPadInput, setCurrentDialPadInput] = useState(
    userAgentSingleton.dialpadInput ?? ''
  );
  const [defean, setDefean] = useState(userAgentSingleton.defean);
  const [mute, setMute] = useState(userAgentSingleton.mute);
  const history = useHistory();

  const typeInDialPad = (value) => {
    setCurrentDialPadInput(currentDialPadInput + value);
    if (userAgentSingleton.session != undefined) {
      userAgentSingleton.sendDTMF(value);
    }
  };

  return (
    <div className="dialpadModal">
      <div className="ramalRow">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <FaHeadset
            strokeWidth={2}
            size={'1rem'}
            style={{
              cursor: 'pointer',
              borderRadius: '5%',
              fontWeight: 'bold',
              fontSize: '1.4rem',
              marginRight: '6px'
            }}
          />
          <p>{ramal}</p>
        </div>

        {userAgentSingleton.session?._state != 'Established' &&
        localStorage.getItem('webrtc_auto_login') === 'false' ? (
          <div className="disconnectButton" onClick={onDisconnect}>
            <FiLogOut />
            <p>Desconectar</p>
          </div>
        ) : verifyRoles(['MONITORING_PBXIP']) &&
          userAgentSingleton.session?._state == 'Established' ? (
          <div
            className="transferButton"
            onClick={() => {
              setOpen(false);
              history.push('/admin/monitoring/extensions');
            }}
          >
            <FaExchangeAlt />
            <p>Transferir</p>
          </div>
        ) : null}
      </div>

      {receivedInvitation == undefined ? (
        <div className="numPan">
          <div className="disp">
            <input
              value={currentDialPadInput}
              onChange={(event) => {
                event.stopPropagation();
                event.preventDefault();
                setCurrentDialPadInput(event.target.value);
              }}
              type="text"
            ></input>
          </div>
          <div className="nums">
            <div className="r r1 ">
              <div onClick={() => typeInDialPad(1)}>
                <span>1</span>
              </div>
              <div onClick={() => typeInDialPad(2)}>
                <span>2</span>
              </div>
              <div onClick={() => typeInDialPad(3)}>
                <span>3</span>
              </div>
            </div>
            <div className="r r2 ">
              <div onClick={() => typeInDialPad(4)}>
                <span>4</span>
              </div>
              <div onClick={() => typeInDialPad(5)}>
                <span>5</span>
              </div>
              <div onClick={() => typeInDialPad(6)}>
                <span>6</span>
              </div>
            </div>
            <div className="r r3 ">
              <div onClick={() => typeInDialPad(7)}>
                <span>7</span>
              </div>
              <div onClick={() => typeInDialPad(8)}>
                <span>8</span>
              </div>
              <div onClick={() => typeInDialPad(9)}>
                <span>9</span>
              </div>
            </div>
            <div className="r r4 ">
              <div onClick={() => typeInDialPad('*')}>
                <span>*</span>
              </div>
              <div onClick={() => typeInDialPad(0)}>
                <span>0</span>
              </div>
              <div onClick={() => typeInDialPad('#')}>
                <span>#</span>
              </div>
            </div>
            {callState == SessionState.Initial ? (
              <div className="call">
                <div
                  onClick={() => {
                    userAgentSingleton.call(currentDialPadInput);
                  }}
                >
                  <FaPhone />
                </div>
              </div>
            ) : (
              <div className="endCall">
                <div
                  onClick={() => {
                    userAgentSingleton.endCall();
                  }}
                >
                  <FaPhoneSlash />
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="receivedInvitation">
          <div>
            <p>{userAgentSingleton.getSessionDisplayName()}</p>
            <p>{userAgentSingleton.getSessionNumber()}</p>
          </div>
          <div className="receivedInvitationActions">
            <div
              className="call"
              onClick={() => {
                receivedInvitation.accept();
              }}
            >
              <div>
                <FaPhone />
              </div>
            </div>
            <div
              className="endCall"
              onClick={() => {
                userAgentSingleton.setLostSessionAsFalse();
                receivedInvitation.reject();
              }}
            >
              <div>
                <FaPhoneSlash />
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="dialpad-toolbar">
        <div style={{ display: 'flex ' }}>
          {verifyRoles(['MONITORING_PBXIP']) ? (
            <div
              className="monitor"
              onClick={() => {
                setOpen(false);
                history.push('/admin/monitoring/extensions');
              }}
            >
              <div>
                <FiMonitor size={22} title="Ir para monitoramento de ramais" />
              </div>
            </div>
          ) : null}

          <div className="statusRow">
            <div
              style={{
                color: callStateColor
              }}
            >
              <FaCircle size={10} />
            </div>
            <p>{`${callStateStatus ?? 'Desconectado'} ${
              userAgentSingleton.session != undefined &&
              userAgentSingleton.session.state != SessionState.Initial
                ? `- ${userAgentSingleton.getSessionNumber()}`
                : ''
            }`}</p>
          </div>
        </div>
        <div className="dialpad-audio-toolbar">
          <div
            className="defean"
            onClick={() => {
              setDefean(!defean);
              setMute(!defean);
              userAgentSingleton.toggleDefean();
              userAgentSingleton.toggleMute(!defean);
            }}
          >
            <div>
              {defean ? <MdHeadsetOff size={22} /> : <MdHeadset size={22} />}
            </div>
          </div>

          <div
            className="mute"
            onClick={() => {
              setMute(!mute);
              userAgentSingleton.toggleMute();
            }}
          >
            <div>{mute ? <MdMicOff size={22} /> : <MdMic size={22} />}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DialpadWebRTC;
